module.exports = __webpack_public_path__ + "img/instagram.f95c5525.png";